import { useState } from 'react';

import type { IssuedApiKey } from '@/entities/integration';

import { ApiKeysCard } from './components/ApiKeysCard';
import { ConnectGuideCard } from './components/ConnectGuideCard';
import { useApiKeys, type ApiKeyOwner } from './hooks';

/**
 * Koppelingen: de sleutels en de uitleg, naast elkaar op één plek.
 *
 * Voor een keuringsbedrijf staat dit onder Instellingen → Koppelingen, voor het
 * platform onder Platformbeheer → Koppelingen. Een net gemaakte sleutel staat in beide
 * kaarten: om te kopiëren, en al ingevuld in de voorbeelden.
 */
export function IntegrationsPanel({ owner }: { owner: ApiKeyOwner }) {
    const keys = useApiKeys(owner);
    const [issued, setIssued] = useState<IssuedApiKey | null>(null);

    return (
        <div className="flex max-w-[1120px] flex-col gap-[14px]">
            <ApiKeysCard owner={owner} issued={issued} onIssued={setIssued} />
            <ConnectGuideCard
                owner={owner}
                addresses={issued?.addresses ?? keys.data?.addresses}
                secret={issued?.secret ?? null}
            />
        </div>
    );
}
